import * as React from 'react';
import classNames from 'classnames';

import './CheckboxPositions.scss';
import Tooltip from 'rc-tooltip';
import MESSAGES from './CheckboxPositions.messages';
import { FormattedMessage } from 'react-intl';

export interface CheckboxPositionsProps {
  defaults: any[];
  enabled: boolean[];
  id: string;
  disabled: boolean;
  division?: 'quarters';
  className?: string;
  positionChange?(positions: boolean[]): void;
  conflictingPositions?: boolean[] | false | null;
}

export interface CheckboxPositionsState {
  changedTooltipPositions: boolean[];
}

export class CheckboxPositions extends React.Component<CheckboxPositionsProps, CheckboxPositionsState> {
  constructor(props: CheckboxPositionsProps) {
    super(props);

    this.state = {
      changedTooltipPositions: []
    }

    this.handleChange = this.handleChange.bind(this);
  }
  
  public render() {
    const {
      defaults,
      enabled,
      id,
      disabled,
      division,
      className,
      conflictingPositions
    } = this.props;

    return (
      <div className={className+" partial-checkbox-positions"}>
        <div className="row my-4">
          <div className="col-12">
            <div className="d-flex position-relative">
              <div className="rc-slider-rail" />
              <div className="rc-slider-track rc-slider-track-1 w-100"/>
              {this.defaults.map((position, index) => { // Loops through the options (not troughs)
                const key = `${id}_position_checkbox_${index}`;
                const checked = position || defaults && defaults[index] ? true : false;
                const isFirst = index === 0;
                const isLast = defaults.length === index + 1;
                const hasTroughAfter = division === 'quarters' ? isFirst || index % 3 === 0 : !isLast;
                const checkDisabled = disabled || (!enabled[index]);
                const tooltipTrigger: any = checkDisabled ? ['hover'] : []; // 'click' prevents us from using the input checkbox...

                const input = (
                  <label className={classNames('d-block p-0', {disabled: checkDisabled})}>
                    <input
                      checked={checked}
                      className={classNames({disabled: checkDisabled})}
                      name={`${id}_left_${index}`}
                      onChange={(event) => !checkDisabled && this.handleChange(event, index)}
                      type="checkbox"
                      value={(position !== false).toString()}
                    />
                    <span className="checkmark" />
                  </label>
                );

                const tooltip = (
                  <Tooltip
                    prefixCls="rc-slider-tooltip"
                    overlay={<FormattedMessage {...MESSAGES.checkboxPositionsNoSpace} />}
                    placement="top"
                    destroyTooltipOnHide={false}
                    trigger={tooltipTrigger}
                  >
                    {input}
                  </Tooltip>
                )
                
                const showRailChangedTooltip = id === 'tissue_dispenser_positions' && conflictingPositions && conflictingPositions[index] && this.state.changedTooltipPositions[index];

                const railChangedTooltip = showRailChangedTooltip && (
                  <Tooltip
                    prefixCls="rc-slider-tooltip"
                    overlay={<FormattedMessage {...MESSAGES.checkboxPositionsTissueConflict} />}
                    placement="top"
                    destroyTooltipOnHide={false}
                    visible={true}
                  >
                    {input}
                  </Tooltip>
                );

                
                // Key must change... otherwise React tries to do some clever shit with merging objects, which ends up making the tooltip always visible... and we cant make it visible: false in the original because then it never shows up!!
                return (
                  <React.Fragment key={showRailChangedTooltip ? key+'_changed' : key}>
                    <div
                      className="partial-checkbox-positions-item flex-fill position-relative" 
                    >
                      {showRailChangedTooltip ? railChangedTooltip : tooltip}
                    </div>
                    {hasTroughAfter && (
                      <div className="partial-checkbox-positions-handle flex-fill position-relative">
                        <div className="rc-slider-handle"/>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private get defaults(): any[] {
    return this.props.defaults;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>, index: number) {
    const positions = JSON.parse(JSON.stringify(this.props.defaults));
    const target = event.target as HTMLInputElement;
    const checked = target.checked;
    
    positions[index] = checked;

    if (this.props.positionChange) {
      this.props.positionChange(positions);
    }

    const current = this.state.changedTooltipPositions;
    current[index] = true;

    this.setState({
      ...this.state,
      changedTooltipPositions: current
    });
    setTimeout(() => { 
      current[index] = false;

      this.setState({
        ...this.state,
        changedTooltipPositions: current
      });
    }, 3500);
  }
}

export default CheckboxPositions;